import React from 'react';

const Flashcard = ({ 
  flashcard, 
  onNext, 
  onPrevious, 
  hasNext, 
  hasPrevious, 
  currentIndex, 
  totalCards, 
  showAnswer, 
  onShowAnswer,
  theme
}) => {
  const handleNext = () => {
    onNext();
  };

  const handlePrevious = () => {
    onPrevious();
  };

  if (!flashcard) {
    return <div>No flashcard selected</div>;
  }

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px' }}>
      <div style={{ 
        marginBottom: '15px', 
        textAlign: 'center',
        backgroundColor: '#F7EEE5',
        padding: '12px',
        borderRadius: '8px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        transition: 'background-color 0.3s ease'
      }}>
        <strong style={{ 
          color: '#28341C',
          fontSize: '16px',
          fontWeight: '600'
        }}>Card {currentIndex + 1} of {totalCards}</strong>
      </div>
      
      <div style={{ 
        border: `2px solid ${theme.secondary}`, 
        borderRadius: '16px', 
        padding: '30px', 
        marginBottom: '20px',
        backgroundColor: theme.cardBackground,
        minHeight: '500px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
        transition: 'all 0.3s ease'
      }}>
        <h3 style={{ 
          marginBottom: '25px',
          color: theme.text,
          fontSize: '1.3rem',
          fontWeight: '700',
          borderBottom: `2px solid ${theme.optionBackground}`,
          paddingBottom: '10px'
        }}>Question {flashcard.id}</h3>
        <p style={{ 
          fontSize: '17px', 
          lineHeight: '1.6', 
          marginBottom: '25px',
          color: theme.text,
          fontWeight: '500'
        }}>
          {flashcard.question}
        </p>
        
        <div style={{ marginBottom: '25px', flex: '1' }}>
          {flashcard.options.map((option, index) => (
            <div
              key={index}
              style={{
                padding: '15px 18px',
                margin: '8px 0',
                border: `2px solid ${showAnswer && option.is_correct ? '#28341C' : theme.secondary}`,
                borderRadius: '10px',
                backgroundColor: showAnswer && option.is_correct ? '#4D5C3C' : theme.optionBackground,
                color: showAnswer && option.is_correct ? '#F7EEE5' : theme.text,
                fontWeight: showAnswer && option.is_correct ? '600' : '500',
                fontSize: '15px',
                transition: 'all 0.3s ease',
                cursor: 'default',
                boxShadow: showAnswer && option.is_correct ? '0 4px 12px rgba(77, 92, 60, 0.3)' : '0 2px 6px rgba(0,0,0,0.05)'
              }}
            >
              <strong style={{ 
                color: showAnswer && option.is_correct ? '#F7EEE5' : theme.text,
                marginRight: '8px'
              }}>{option.label}.</strong> 
              <span>{option.text}</span>
            </div>
          ))}
        </div>
        
        <div style={{ marginTop: 'auto' }}>
          {!showAnswer && (
            <button
              onClick={onShowAnswer}
              style={{
                padding: '15px 30px',
                backgroundColor: theme.primary,
                color: theme.textLight,
                border: 'none',
                borderRadius: '10px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600',
                transition: 'all 0.2s ease',
                boxShadow: '0 4px 12px rgba(40, 52, 28, 0.3)',
                width: '100%'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = theme.secondary}
              onMouseOut={(e) => e.target.style.backgroundColor = theme.primary}
            >
              Show Correct Answer
            </button>
          )}
        </div>
      </div>
      
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        gap: '15px'
      }}>
        <button
          onClick={handlePrevious}
          disabled={!hasPrevious}
          style={{
            padding: '15px 25px',
            backgroundColor: hasPrevious ? '#F7EEE5' : '#364327',
            color: hasPrevious ? '#28341C' : '#F7EEE5',
            border: 'none',
            borderRadius: '10px',
            cursor: hasPrevious ? 'pointer' : 'not-allowed',
            fontSize: '16px',
            fontWeight: '600',
            flex: '1',
            transition: 'all 0.2s ease',
            boxShadow: hasPrevious ? '0 4px 12px rgba(247, 238, 229, 0.3)' : 'none',
            opacity: hasPrevious ? '1' : '0.6'
          }}
          onMouseOver={(e) => hasPrevious && (e.target.style.backgroundColor = '#4D5C3C')}
          onMouseOut={(e) => hasPrevious && (e.target.style.backgroundColor = '#F7EEE5')}
        >
          ← Previous
        </button>
        
        <button
          onClick={handleNext}
          disabled={!hasNext}
          style={{
            padding: '15px 25px',
            backgroundColor: hasNext ? '#F7EEE5' : '#364327',
            color: hasNext ? '#28341C' : '#F7EEE5',
            border: 'none',
            borderRadius: '10px',
            cursor: hasNext ? 'pointer' : 'not-allowed',
            fontSize: '16px',
            fontWeight: '600',
            flex: '1',
            transition: 'all 0.2s ease',
            boxShadow: hasNext ? '0 4px 12px rgba(247, 238, 229, 0.3)' : 'none',
            opacity: hasNext ? '1' : '0.6'
          }}
          onMouseOver={(e) => hasNext && (e.target.style.backgroundColor = '#4D5C3C')}
          onMouseOut={(e) => hasNext && (e.target.style.backgroundColor = '#F7EEE5')}
        >
          Next →
        </button>
      </div>
    </div>
  );
};

export default Flashcard;
